<template src='./profile-dialog.html'></template>


<script>
import PurchaseDialog from './PurchaseDialog';
import BaseModule from '../BaseModule' 

export default {
  name: "ProfileDialog",
  mixins: [BaseModule],
  components: { PurchaseDialog },
  props: {},
  data() {
    return {
      show: false,
      rundownApp: null,
      fullNameText: "",
      userMailText: "",
      showPremium: true, 
      validLicense: false,
      waitingPurchase: false,
      showUpdateMessage: true,
    };
  },
  methods: {
    close()
        {
            this.show=false
            window.rundownApp.device.backButtonCallback = null;
        },
    waitForPurchase(purchase) {
      //window.rundownApp.showBusy(true);
      this.waitingPurchase=true;
      console.log('waitForPurchase:'+purchase);
    },
    manageSubscriptions() {
      window.rundownApp.purchases.manageSubscriptions();
    },
    updateApp() {
            if (window.rundownApp.device.platform==="ios")
              window.sp_openURl(window.appstore_link);
            else
              window.sp_openURl(window.googleplay_link);
        },
    handleProfile(rundownApp) {
      this.show = true;
      this.fullNameText =
        rundownApp.user.firstname + " " + rundownApp.user.lastname;
      this.userMailText = rundownApp.user.email;
      this.rundownApp = rundownApp;
      this.licenseExpirationDate = rundownApp.user.licenseExpirationDate;
      this.licenseSeats = rundownApp.user.licenseSeats;
      this.showPremium =  window.vueapp.showPremiumMode();
      this.showUpdateMessage = window.vueapp.appUpdateRequired() && this.expiredlicense();
      this.validLicense= !this.expiredlicense();

      window.rundownApp.device.backButtonCallback = this.close;
    },
    isIOS() {
      return window.sendCordovaWrapperMessage("ISIOS:ON");
    },
    showPrivacy() {
      window.sp_openURl(window.discovery.privacy_policy_link);
    },
    showTerms() {
      window.sp_openURl(window.discovery.terms_of_use_link);
    },
    expiredlicense() {
      let moment = new Date().getTime();

      if (this.licenseExpirationDate) {
        if (this.licenseSeats > 2 && this.licenseExpirationDate > moment) {
          return false;
        }
      }

      return true;
    },
    showPurchase() {
      if (window.rundownApp.isCordova) {
        //window.sendCordovaWrapperMessage("ORDERPURCHASE:ON");
        this.$refs["purchaseDialog"].showPurchaseDialog();
      } else {
        this.show = false;
        window.$("#premium-mode-only-mobile-rundown").show();
      }
    },
    changePassword() {
      this.show = false;
      var shareManager = window.rundownApp.shareManager.getInstance();
      shareManager.ViewModel.changePassword();
    },
    goToProfile() {
      this.show = false;
      window.vueapp.handleProfileDialog(window.rundownApp);
    },
    activatePremiumIOS() {
      window.sendCordovaWrapperMessage("RESTOREPURCHASES:ON");
    },
    onPurchaseCompleted(product){

       console.log('onPurchaseCompleted:'+this.waitingPurchase+':'+product.state);
      
        var state = product.state;
        var editor = window.rundownApp.shareManager.getInstance();

        //window.$("#info-purchase-fail").hide();
        //window.$("#loadingLayer").show();

        switch (state) {
            case 'requested':
                window.rundownApp.showBusy(true);			
                break;
            case 'approved':			
                if (this.waitingPurchase===false) return;
                editor.goToFinishPurchase(); 
                this.waitingPurchase=false;
                break;
            case 'cancelled':
                editor.goToCancelPurchase("cancelPurchase");	
                window.rundownApp.showBusy(false);
                this.waitingPurchase=false;		
                break;
            case 'valid':
            case 'owned':
            case 'finished':
            default:
                window.rundownApp.showBusy(false);
                //editor.goToCancelPurchase('errorPurchase');			
                break;	
        }	
    },
  },
  filters: {},
  computed: {},
  created() {},
  mounted() {},
  updated() {},
  destroyed() {},
};
 
</script>


<style>
</style>
